import { MagnifyingGlassIcon } from '@heroicons/react/20/solid';

export const NoAlerts = ({ text = 'Search for a bond to add an alert' }: { text?: string }) => {
  return (
    <div className="bg-[#333557] flex flex-col mx-[1.25rem] mt-[1.25rem] place-items-center py-[2rem] rounded-[0.625rem] text-[#DDDDE2] sm:py-[2.5rem] sm:text-[1.25rem]">
      <MagnifyingGlassIcon className="h-[2rem] mb-[0.2rem] text-[#C9CADE] sm:h-[2.8rem]" />
      <span>{text}</span>
    </div>
  )
}